import { render, staticRenderFns } from "./CancelService.vue?vue&type=template&id=567f6047"
import script from "./CancelService.vue?vue&type=script&lang=js"
export * from "./CancelService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports